import { Card } from "react-rainbow-components";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 1rem 2rem;
  flex-direction: column;
  @media only screen and (max-width: 600px) {
    padding: 0.5rem;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 1.75rem 0;
  height: fit-content;
  & > h1 {
    margin: 0;
    color: #123559;
    margin-left: 1rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.25rem;
    }
  }
`;

export const ContainerContent = styled.div`
  display: flex;
  flex: 1;
  height: auto;
`;

export const ContainerCoupon = styled.div`
  width: 400px;
  margin-right: 1rem;
  overflow-y: scroll;
  padding: 1rem;
  padding-top: 0;
  max-height: 55vh;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
`;

export const ContainerListUser = styled.div`
  flex: 1;
  display: flex;
  overflow-y: scroll;
  max-height: 55vh;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
`;

export const ContentCoupon = styled.div`
  padding: 1rem;
  border-left: 0.5rem solid #f2f2f2;
  cursor: pointer;

  &.active {
    border-left: 0.5rem solid #123559;
  }

  > h5 {
    display: -webkit-box;
    max-width: 350px;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  > p {
    display: -webkit-box;
    max-width: 350px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const BubleEdit = styled.div`
  background-color: #fff;
  border-radius: 9999px;
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  transition: all 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    transition: all 0.5s ease;
    transform: scale(1.5);
  }
`;

export const CardCoupon = styled(Card)`
  margin: 0.5rem 0;
`;
